var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sw-ContactNote"},[_c('strong',[_vm._v("\n    "+_vm._s(_vm.noteTitle)+"\n\n  ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.noteDesc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }